import * as moment from "moment"
import { dealerSignal } from "../../../../signal/dealerSignal"
import { productSignal } from "../../../../signal/productSignal"
import { getProducts } from "../../../../utilities/getProducts"
import { TallyConfig } from "../helpers/constants"
import { DEV_SERVER } from "../../../../constants/urls"
import axios from "axios"
import { userSignal } from "../../../../signal/userSignal"
import { getDealers } from "../../../../utilities/getDealers"
import { stateNameFormatter } from "../../../../utilities/stateNameFormatter"
import { organisationSignal } from "../../../../signal/organisationSignal"


export async function SyncSalesVouchers(vouchers, startDate, endDate) {
    try {
        if (!vouchers) {
            console.log("vouchers not found")
            return false
        }

        vouchers = vouchers?.ENVELOPE?.BODY?.DATA?.COLLECTION?.VOUCHER || []

        if(!(vouchers instanceof Array)){
            vouchers = [vouchers]
        }

        if (vouchers.length === 0) {
            return true
        }

        let productsMap = {}

        if (!productSignal.value) {
            await getProducts()
        }

        Object.keys(productSignal.value).map((key) => {
            let product = productSignal.value[key]
            productsMap[product.name] = product
        })

        let dealersMap = {}

        if (!dealerSignal.value) {
            console.log("fetching dealers in syncvoucher")
            await getDealers()
        }

        Object.keys(dealerSignal.value).map((key) => {
            let dealer = dealerSignal.value[key]
            dealersMap[dealer.name.trim()] = dealer
        })

        let data = []

        let alterId = 0

        let startTime = moment(startDate).valueOf()
        let endTime = moment(endDate).endOf('day').valueOf()
        let masterIds = []

        for (let i = 0; i < vouchers.length; i++) {
            let voucher = vouchers[i]

            if (!voucher) {
                continue
            }

            if(voucher?.ISINVOICE?._text !== "Yes"){
                continue
            }

            let order = {}

            let orderItems = []

            let salesLedger = ""
            let godown = ""

            let inventories = voucher["ALLINVENTORYENTRIES.LIST"] || []

            if(!(inventories instanceof Array)){
                inventories = [inventories]
            }

            for (let j = 0; j < inventories.length; j++) {
                let inventory = inventories[j]

                let product = productsMap[inventory?.STOCKITEMNAME?._text]

                if (!product) {
                    console.log("product not found", inventory?.STOCKITEMNAME?._text)
                    j = inventories.length + 1
                    continue
                }
                let orderItem = {
                    productId: product?.id,
                }

                let billedQty = inventory?.BILLEDQTY?._text
                if (!billedQty) {
                    console.log("billedQty not found", voucher)
                    j = inventories.length + 1
                    continue
                }
                billedQty = billedQty.trim().split(' ')
                orderItem.quantity = parseInt(billedQty[0])

                orderItem.packagingType = billedQty?.length>=2 ? billedQty[1] : product?.tallyVatBaseUnit

                let rate = inventory?.RATE?._text || "/"
                rate = rate.split('/')

                orderItem.price = parseFloat(rate?.length>0 ? rate[0] : 0)

                let discount = inventory?.DISCOUNT?._text || ""
                if (discount) {
                    discount = discount.trim()
                }

                discount = parseFloat(discount) || 0
                
                orderItem.discount = discount

                orderItems.push(orderItem)

                if (inventory["ACCOUNTINGALLOCATIONS.LIST"]?.LEDGERNAME) {

                    if (inventory["ACCOUNTINGALLOCATIONS.LIST"]?.LEDGERNAME?.length > 0) {
                        salesLedger = inventory["ACCOUNTINGALLOCATIONS.LIST"]?.LEDGERNAME[0]?._text || ""
                    } else {
                        salesLedger = inventory["ACCOUNTINGALLOCATIONS.LIST"].LEDGERNAME._text || ""
                    }
                }

                if (inventory["BATCHALLOCATIONS.LIST"]?.GODOWNNAME) {

                    if (inventory["BATCHALLOCATIONS.LIST"]?.GODOWNNAME?.length > 0) {
                        godown = inventory["BATCHALLOCATIONS.LIST"]?.GODOWNNAME[0]?._text || ""
                    } else {
                        godown = inventory["BATCHALLOCATIONS.LIST"].GODOWNNAME._text || ""
                    }
                }


            }

            if (orderItems.length === 0) {
                continue
            }

            order.orderItems = orderItems

            let shippingAddress = ""
            let billingAddress = ""

            if (voucher["ADDRESS.LIST"]?.ADDRESS) {

                if (voucher["ADDRESS.LIST"]?.ADDRESS?.length > 0) {
                    shippingAddress = voucher["ADDRESS.LIST"]?.ADDRESS?.map((address) => address?._text).join(", ") || ""
                } else {
                    shippingAddress = voucher["ADDRESS.LIST"].ADDRESS._text
                }
            }

            order.shippingAddress = {
                addressL1: shippingAddress,
            }

            if (voucher["BASICBUYERADDRESS.LIST"]?.BASICBUYERADDRESS) {

                if (voucher["BASICBUYERADDRESS.LIST"]?.BASICBUYERADDRESS?.length > 0) {
                    billingAddress = voucher["BASICBUYERADDRESS.LIST"]?.BASICBUYERADDRESS?.map((address) => address?._text).join(", ") || ""
                } else {
                    billingAddress = voucher["BASICBUYERADDRESS.LIST"].BASICBUYERADDRESS._text
                }
            }

            order.billingAddress = {
                addressL1: billingAddress,
            }

            let dealer = dealersMap[voucher?.BASICBUYERNAME?._text.trim()]

            if (!dealer) {
                continue
            }

            order.dealerId = dealer.id
            order.dealerState = stateNameFormatter(dealer?.state)
            order.managerId = dealer.managerId
            order.createdAt = moment(voucher?.DATE?._text, "YYYYMMDD").valueOf()

            if(order.createdAt < startTime) {
                startTime = order.createdAt
            }

            if(order.createdAt > endTime) {
                endTime = moment(order.createdAt).endOf('day').valueOf()
            }

            let ledgerEntries = voucher["LEDGERENTRIES.LIST"] || []

            if(!(ledgerEntries instanceof Array)){
                ledgerEntries = [ledgerEntries]
            }

            let taxes = []

            for (let j = 1; j < ledgerEntries.length; j++) {
                let ledgerEntry = ledgerEntries[j]

                let tax = {
                    name: ledgerEntry?.LEDGERNAME?._text,
                    taxInAmount: parseFloat(ledgerEntry?.AMOUNT?._text) || 0
                }

                if (ledgerEntry["RATEOFINVOICETAX.LIST"]?.RATEOFINVOICETAX) {

                    if (ledgerEntry["RATEOFINVOICETAX.LIST"]?.RATEOFINVOICETAX?.length > 0) {
                        tax.taxInPercentage = parseFloat(ledgerEntry["RATEOFINVOICETAX.LIST"]?.RATEOFINVOICETAX[0]?._text) || 0
                    } else {
                        tax.taxInPercentage = parseFloat(ledgerEntry["RATEOFINVOICETAX.LIST"].RATEOFINVOICETAX._text || 0)
                    }
                }else{
                    tax.taxInPercentage = 0
                }

                taxes.push(tax)
            }

            if (taxes.length !== 0) {
                order.taxes = taxes
            }

            let tallySalesVoucherDetails = {
                voucherNumber: voucher?.MASTERID?._text.trim() || "",
                voucherType: voucher?.VOUCHERTYPENAME?._text || "",
                salesLedger: salesLedger,
                priceLevel: voucher?.PRICELEVEL?._text || "",
                godown: godown,
                taxesLedger: taxes.map(tax => tax.name) || [],
                companyName: TallyConfig.company,
                remoteId: voucher?._attributes?.REMOTEID || "",
                voucherKey: voucher?._attributes?.VCHKEY || "",
                alterId: voucher?.ALTERID?._text || "",
                guId: voucher?.GUID?._text || "",
                dealerName: voucher?.BASICBUYERNAME?._text || "",
            }

            if (voucher?.IRNACKDATE?._text && voucher?.IRNACKDATE?._text !== ""){
                tallySalesVoucherDetails.irnAckDate = moment(voucher?.IRNACKDATE?._text, "YYYYMMDD").valueOf()
            }

            if (voucher?.IRN?._text && voucher?.IRN?._text !== ""){
                tallySalesVoucherDetails.irn = voucher?.IRN?._text || ""
            }

            if (voucher?.IRNQRCODE?._text && voucher?.IRNQRCODE?._text !== "") {
                tallySalesVoucherDetails.irnQRCode = voucher?.IRNQRCODE?._text || ""
            }

            if (voucher?.IRNACKNO?._text && voucher?.IRNACKNO?._text!=="") {
                tallySalesVoucherDetails.irnAckNo = voucher?.IRNACKNO?._text || ""
            }

            if (voucher?.ISOPTIONAL?._text && voucher?.ISOPTIONAL?._text!=="") {
                tallySalesVoucherDetails.isOptional = voucher?.ISOPTIONAL?._text?.toLowerCase() === "yes" ? true : false
            }

            if (voucher?.VOUCHERNUMBER?._text && voucher?.VOUCHERNUMBER?._text!=="") {
                tallySalesVoucherDetails.voucherInvoiceNumber = voucher?.VOUCHERNUMBER?._text || ""
            }

            masterIds.push(tallySalesVoucherDetails.voucherNumber)

            let dealerMasterId = ""

            if (dealer?.tallyDetails) {
                for (let j = 0; j < dealer.tallyDetails.length; j++) {
                    let tallyDetail = dealer.tallyDetails[j]
                    if (tallyDetail.companyName === TallyConfig.company) {
                        dealerMasterId = tallyDetail.masterId
                        break
                    }
                }
            }

            tallySalesVoucherDetails.dealerMasterId = dealerMasterId

            order.tallySalesVoucherDetails = tallySalesVoucherDetails

            let _alterId = voucher?.ALTERID?._text || ""
            _alterId = parseInt(_alterId)

            if (_alterId > alterId) {
                alterId = _alterId
            }

            data.push(order)
        }

        let resp = await window.electron.grpcConnect({
            userId: userSignal?.value?.user.id,
            organisationId: userSignal?.value?.user?.organisation,
            reqType: "syncOrders",
            orders: JSON.stringify(data),
            startTime: startTime,
            endTime: endTime,
            ids: masterIds,
            companyName: TallyConfig.company
        })

        // wait for 25s
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve()
            }, 5000)
        })

        return true

        // let resp = await axios.post(`${DEV_SERVER}/order/v2/syncWithTally`, data, {
        //     headers: {
        //         Authorization: `Bearer ${userSignal?.value?.token}`
        //     }
        // })

        // data = resp?.data

        // if (data.status) {
        //     return true
        // } else {
        //     return false
        // }

    }catch(err){
        console.log(err)
        return false
    }
}

export async function SyncReceiptVouchers(vouchers, startDate, endDate) {
    try {
        if (!vouchers) {
            return false
        }

        vouchers = vouchers?.ENVELOPE?.BODY?.DATA?.COLLECTION?.VOUCHER || []

        if(!(vouchers instanceof Array)){
            vouchers = [vouchers]
        }

        if (vouchers.length === 0) {
            return true
        }

        let dealersMap = {}

        if (!dealerSignal.value) {
            await getDealers()
        }

        Object.keys(dealerSignal.value).map((key) => {
            let dealer = dealerSignal.value[key]
            dealersMap[dealer.name.trim()] = dealer
        })

        let data = []

        let alterId = 0;

        let startTime = moment(startDate).valueOf()
        let endTime = moment(endDate).endOf('day').valueOf()
        let masterIds = []

        for (let i = 0; i < vouchers.length; i++) {
            let voucher = vouchers[i]

            if (!voucher) {
                continue
            }

            if(voucher?.HASCASHFLOW?._text !== "Yes"){
                continue
            }

            let ledgerEntries = voucher["ALLLEDGERENTRIES.LIST"] || []

            if(!(ledgerEntries instanceof Array)){
                ledgerEntries = [ledgerEntries]
            }

            let payemnt = {}

            let firstLedgerEntry = ledgerEntries.length > 0 ? ledgerEntries[0] : null

            if (!firstLedgerEntry) {
                console.log("firstLedgerEntry not found", voucher)
                continue
            }

            let dealer = firstLedgerEntry?.LEDGERNAME?._text || ""
            let amount = firstLedgerEntry?.AMOUNT?._text || 0

            if (!dealer) {
                console.log("dealer not found", firstLedgerEntry)
                continue
            }

            let dealerDetails = dealersMap[dealer.trim()]

            if (!dealerDetails) {
                console.log("dealerDetails not found", dealer, dealersMap)
                continue
            }

            payemnt.dealerId = dealerDetails.id
            payemnt.managerId = dealerDetails.managerId
            payemnt.amount = parseFloat(amount)
            payemnt.remark = voucher?.NARRATION?._text || ""

            let secondLedgerEntry = ledgerEntries.length > 1 ? ledgerEntries[1] : null

            if (secondLedgerEntry) {
                payemnt.paymentType = secondLedgerEntry?.LEDGERNAME?._text || ""
            }

            payemnt.createdAt = moment(voucher?.DATE?._text, "YYYYMMDD").valueOf()

            if (payemnt.createdAt < startTime) {
                startTime = payemnt.createdAt
            }

            if (payemnt.createdAt > endTime) {
                endTime = moment(payemnt.createdAt).endOf('day').valueOf()
            }

            let tallyReceiptVoucherDetails = {
                voucherNumber: voucher?.MASTERID?._text.trim() || "",
                voucherType: voucher?.VOUCHERTYPENAME?._text || "",
                companyName: TallyConfig.company,
                bankAccount: payemnt.paymentType!=="" ? payemnt.paymentType : "",
                remoteId: voucher?._attributes?.REMOTEID || "",
                voucherKey: voucher?._attributes?.VCHKEY || "",
                alterId: voucher?.ALTERID?._text || "",
                guId: voucher?.GUID?._text || "",
                dealerName: dealer,
            }

            masterIds.push(tallyReceiptVoucherDetails.voucherNumber)

            let dealerMasterId = ""

            if (dealerDetails?.tallyDetails) {
                for (let j = 0; j < dealerDetails.tallyDetails.length; j++) {
                    let tallyDetail = dealerDetails.tallyDetails[j]
                    if (tallyDetail.companyName === TallyConfig.company) {
                        dealerMasterId = tallyDetail.masterId
                        break
                    }
                }
            }

            tallyReceiptVoucherDetails.dealerMasterId = dealerMasterId

            payemnt.tallyReceiptVoucherDetails = tallyReceiptVoucherDetails

            let _alterId = voucher?.ALTERID?._text || ""
            _alterId = parseInt(_alterId)

            if (_alterId > alterId) {
                alterId = _alterId
            }

            data.push(payemnt)
        }

        let resp = await window.electron.grpcConnect({
            userId: userSignal?.value?.user.id,
            organisationId: userSignal?.value?.user?.organisation,
            reqType: "syncPayments",
            payments: JSON.stringify(data),
            startTime: startTime,
            endTime: endTime,
            ids: masterIds,
            companyName: TallyConfig.company
        })

        // wait for 5s
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve()
            }, 5000)
        })

        return true

        // let resp = await axios.post(`${DEV_SERVER}/payment/v2/syncWithTally`, data, {
        //     headers: {
        //         Authorization: `Bearer ${userSignal?.value?.token}`
        //     }
        // })

        // data = resp?.data

        // if (data.status) {
        //     return true
        // } else {
        //     return false
        // }

    }catch(err){
        console.log(err)
        return false
    }
}